"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineAuditHandlers = defineAuditHandlers;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function defineAuditHandlers(handlers) {
    return handlers;
}
